/*!
 * PES Supply — Category Tiles + Promoted Slider v3
 * - Replaces bad category tile images with real product photos
 * - Adds promoted items slider with CURRENT PRODUCTION ONLY
 * - Filters: EOL tags, kit/system/bundle titles, $0 price
 * - Sorts: newest current production first, best value mixed in
 * - Badges: NEW (60d), BEST VALUE ($/W < 0.35), SALE (compare_at > price)
 * - Applies to ALL collection pages, not just solar panels
 * Brand green: #11B67B
 */(function(){"use strict";

var BRAND_GREEN = "#11B67B";

// Better category tile images from real product photos
var CATEGORY_IMAGES = {
  "solar-panels": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/4ebeaa51f7cdfd7ea5e6554d88f6aebc.jpg?v=1785255581",
  "solar-inverters": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/pes_7385141477510.jpg?v=1785258118",
  "hybrid-energy-storage-solutions-battery-grid-integration": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/pes_7385506906246.jpg?v=1785261457",
  "solar-panel-accessories-kits": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/pes_7385422037126.jpg?v=1785260597",
  "chargers-controllers": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/89ca425e8d1ca250e33922757ccb3b90.jpg?v=1785255892",
  "charge-controllers": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/89ca425e8d1ca250e33922757ccb3b90.jpg?v=1785255892",
  "racking": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/pes_7385494159494.jpg?v=1785261349",
  "racking-mounting": "https://cdn.shopify.com/s/files/1/0613/5188/6982/files/pes_7385494159494.jpg?v=1785261349"
};

// Terms that indicate a product is NOT a standalone item (kit, system, bundle, etc.)
var SKIP_TERMS = [' kit', 'system', 'bundle', 'starter', 'package', 'complete', 'diy',
  'expandable', 'telecom', 'off-grid dc', 'rv solar', 'airstream',
  'weekender', 'snapper', 'catfish', 'tiny house', 'pallet', 'load',
  'design diagram', 'installation', 'service', 'wiring', 'remote power',
  'starter kit', 'combo', 'set of', 'pack of'];

// EOL tags that indicate a product is discontinued
var EOL_TAGS = ['eol-discontinued', 'eol-legacy'];

// Collections where $/W pricing and Best Value badges make sense (solar panels only)
var SOLAR_PANEL_COLLECTIONS = [
  'solar-panels', 'solar-panel', 'solar-pv-panels',
  'residential-solar-panels', 'commercial-solar-panels',
  'monocrystalline', 'polycrystalline', 'bifacial'
];

function isSolarPanelCollection(handle) {
  if (!handle) return false;
  var h = handle.toLowerCase();
  if (h.indexOf('solar-panel') >= 0) return true;
  for (var i = 0; i < SOLAR_PANEL_COLLECTIONS.length; i++) {
    if (h === SOLAR_PANEL_COLLECTIONS[i]) return true;
  }
  return false;
}

function injectStyles() {
  if (document.getElementById("pes-tiles-slider-styles")) return;
  var css = document.createElement("style");
  css.id = "pes-tiles-slider-styles";
  css.textContent = [
    // Category tile improvements
    ".collection-subnavigation__item img {",
    "  width: 60px !important; height: 60px !important;",
    "  border-radius: 8px; object-fit: cover;",
    "  border: 2px solid transparent; transition: border-color 0.2s;",
    "}",
    ".collection-subnavigation__item.active img,",
    ".collection-subnavigation__item:hover img {",
    "  border-color: " + BRAND_GREEN + ";",
    "}",
    ".collection-subnavigation__item p {",
    "  font-size: 12px; font-weight: 600; margin-top: 4px;",
    "  color: #0a1628; text-align: center;",
    "}",
    ".collection-subnavigation__item.active p {",
    "  color: " + BRAND_GREEN + ";",
    "}",
    "",
    // Promoted slider
    ".pes-promoted-slider {",
    "  position: relative; margin: 0 0 24px 0; padding: 16px 0;",
    "  background: linear-gradient(135deg, #f8fbf9 0%, #f0f7f3 100%);",
    "  border-radius: 12px; overflow: hidden;",
    "}",
    ".pes-promoted-slider__header {",
    "  display: flex; align-items: center; justify-content: space-between;",
    "  padding: 0 20px 12px; margin: 0;",
    "}",
    ".pes-promoted-slider__title {",
    "  font-size: 18px; font-weight: 800; color: #0a1628;",
    "  display: flex; align-items: center; gap: 8px;",
    "}",
    ".pes-promoted-slider__title svg { width: 20px; height: 20px; color: " + BRAND_GREEN + "; }",
    ".pes-promoted-slider__nav { display: flex; gap: 8px; }",
    ".pes-promoted-slider__btn {",
    "  width: 36px; height: 36px; border-radius: 50%;",
    "  border: 1.5px solid " + BRAND_GREEN + "; background: #fff;",
    "  color: " + BRAND_GREEN + "; cursor: pointer;",
    "  display: flex; align-items: center; justify-content: center;",
    "  font-size: 18px; transition: all 0.2s;",
    "}",
    ".pes-promoted-slider__btn:hover { background: " + BRAND_GREEN + "; color: #fff; }",
    ".pes-promoted-slider__btn:disabled { opacity: 0.4; cursor: default; }",
    ".pes-promoted-slider__track {",
    "  display: flex; gap: 12px; padding: 0 20px;",
    "  overflow-x: auto; scroll-behavior: smooth;",
    "  scrollbar-width: thin; scrollbar-color: " + BRAND_GREEN + " transparent;",
    "  -ms-overflow-style: none;",
    "}",
    ".pes-promoted-slider__track::-webkit-scrollbar { height: 4px; }",
    ".pes-promoted-slider__track::-webkit-scrollbar-thumb { background: " + BRAND_GREEN + "; border-radius: 2px; }",
    ".pes-promoted-slider__track::-webkit-scrollbar-track { background: transparent; }",
    "",
    // CLS guard: space reserved before fetch completes (mirrors server-rendered slot)
    ".pes-promoted-slider-placeholder { height: 400px; margin: 0 0 24px 0; }",
    "@media screen and (max-width: 749px) { .pes-promoted-slider-placeholder { height: 340px; } }",
    "",
    ".pes-promo-card {",
    "  flex: 0 0 200px; background: #fff; border-radius: 10px;",
    "  overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.08);",
    "  transition: box-shadow 0.2s, transform 0.2s;",
    "  text-decoration: none; color: inherit; display: block;",
    "}",
    ".pes-promo-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.15); transform: translateY(-2px); }",
    ".pes-promo-card__image {",
    "  width: 100%; height: 160px; object-fit: contain; background: #f4f6f5;",
    "  display: block; padding: 8px;",
    "}",
    ".pes-promo-card__body { padding: 10px 12px; }",
    ".pes-promo-card__badges { display: flex; gap: 4px; margin-bottom: 6px; flex-wrap: wrap; }",
    ".pes-promo-badge {",
    "  font-size: 9px; font-weight: 700; text-transform: uppercase;",
    "  padding: 2px 7px; border-radius: 999px; letter-spacing: 0.3px;",
    "}",
    ".pes-promo-badge--new { background: " + BRAND_GREEN + "; color: #fff; }",
    ".pes-promo-badge--sale { background: #e53935; color: #fff; }",
    ".pes-promo-badge--value { background: #0a1628; color: #fff; border: 1px solid " + BRAND_GREEN + "; }",
    ".pes-promo-card__title {",
    "  font-size: 12px; font-weight: 600; color: #0a1628;",
    "  line-height: 1.35; margin: 0 0 6px;",
    "  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;",
    "  overflow: hidden; min-height: 32px;",
    "}",
    ".pes-promo-card__price {",
    "  font-size: 16px; font-weight: 800; color: " + BRAND_GREEN + ";",
    "  display: flex; align-items: baseline; gap: 6px;",
    "}",
    ".pes-promo-card__compare {",
    "  font-size: 12px; color: #999; text-decoration: line-through; font-weight: 400;",
    "}",
    ".pes-promo-card__wpd {",
    "  font-size: 11px; color: #6b7c75; font-weight: 600; margin-top: 2px;",
    "}"
  ].join("");
  document.head.appendChild(css);
}

// Replace category tile images with better ones
function fixCategoryTiles() {
  var tiles = document.querySelectorAll('.collection-subnavigation__item');
  tiles.forEach(function(tile) {
    var link = tile.querySelector('a');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var img = tile.querySelector('img');
    if (!img) return;
    
    for (var handle in CATEGORY_IMAGES) {
      if (href.indexOf(handle) >= 0) {
        if (img.src !== CATEGORY_IMAGES[handle]) {
          img.src = CATEGORY_IMAGES[handle];
          img.removeAttribute('srcset');
          img.setAttribute('width', '60');
          img.setAttribute('height', '60');
          var p = tile.querySelector('p');
          if (p) img.alt = p.textContent.trim();
        }
        break;
      }
    }
  });
}

// Check if a product should be excluded
function shouldExclude(product) {
  var title = (product.title || '').toLowerCase();
  var tags = product.tags || '';
  
  // Skip EOL products
  for (var i = 0; i < EOL_TAGS.length; i++) {
    if (tags.indexOf(EOL_TAGS[i]) >= 0) return true;
  }
  
  // Skip kits/systems/bundles
  for (var i = 0; i < SKIP_TERMS.length; i++) {
    if (title.indexOf(SKIP_TERMS[i]) >= 0) return true;
  }
  
  // Skip $0 or very cheap
  var price = 0;
  if (product.variants && product.variants.length) {
    price = parseFloat(product.variants[0].price) || 0;
  }
  if (price < 50) return true;
  
  // Skip if no image
  if (!product.images || !product.images.length) return true;
  
  return false;
}

// Fetch current production products from the storefront
function fetchPromotedProducts() {
  var path = window.location.pathname;
  var collectionMatch = path.match(/\/collections\/([a-z0-9\-]+)/i);
  if (!collectionMatch) return;
  var collectionHandle = collectionMatch[1];
  var isPanelsCollection = isSolarPanelCollection(collectionHandle);

  // CLS guard: reserve slider space up-front so the grid doesn't jump.
  // Reuse the server-rendered slot when the template provides one.
  var gridEarly = document.querySelector('.product-grid, .cust-prodlist-grid, .collection-product-grid, #product-grid, .grid.product-grid, .custm-mn-collecgridlist');
  var placeholder = document.querySelector('.pes-promoted-slider-placeholder');
  if (!placeholder && gridEarly && gridEarly.parentNode && !document.querySelector('.pes-promoted-slider')) {
    placeholder = document.createElement('div');
    placeholder.className = 'pes-promoted-slider-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.appendChild(document.createElement('div'));
    gridEarly.parentNode.insertBefore(placeholder, gridEarly);
  }
  function clearPlaceholder() {
    if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
    placeholder = null;
  }

  // Fetch first 30 products from storefront
  var url = '/collections/' + collectionHandle + '/products.json?limit=30';

  fetch(url)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.products || [];
      if (!products.length) { clearPlaceholder(); return; }
      
      // Filter to current production only
      var filtered = products.filter(function(p) { return !shouldExclude(p); });
      
      // Process each product
      var promoted = filtered.map(function(p) {
        var price = 0, compareAt = 0;
        if (p.variants && p.variants.length) {
          price = parseFloat(p.variants[0].price) || 0;
          compareAt = parseFloat(p.variants[0].compare_at_price) || 0;
        }
        
        var imgSrc = '';
        if (p.images && p.images.length) {
          imgSrc = p.images[0].src || '';
        }
        
        // Extract wattage (only meaningful for solar panels)
        var wattMatch = isPanelsCollection ? p.title.match(/(\d{2,4})\s*[wW](?:att)?\b/) : null;
        var wattage = wattMatch ? parseInt(wattMatch[1]) : 0;
        var wpd = wattage > 0 ? price / wattage : 0;
        
        // Check if new (created in last 60 days)
        var created = new Date(p.created_at || Date.now());
        var daysOld = (Date.now() - created.getTime()) / 86400000;
        var isNew = daysOld < 60;
        
        return {
          handle: p.handle,
          title: p.title,
          price: price,
          compareAt: compareAt > price ? compareAt : null,
          image: imgSrc,
          wattage: wattage,
          wpd: isPanelsCollection && wpd > 0 ? Math.round(wpd * 1000) / 1000 : 0,
          isNew: isNew,
          isSale: compareAt > price,
          isValue: isPanelsCollection && wpd > 0 && wpd < 0.35,
          createdAt: p.created_at || ''
        };
      });
      
      // Sort: for solar panels, best value first; for others, sale items first
      promoted.sort(function(a, b) {
        if (isPanelsCollection) {
          // Best value panels go to top
          if (a.isValue && !b.isValue) return -1;
          if (!a.isValue && b.isValue) return 1;
        } else {
          // For non-panel collections, sale items get boosted
          if (a.isSale && !b.isSale) return -1;
          if (!a.isSale && b.isSale) return 1;
        }
        // Then newest
        var aDate = a.createdAt || '';
        var bDate = b.createdAt || '';
        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        return 0;
      });
      
      // Take top 12
      var sliderProducts = promoted.slice(0, 12);
      if (sliderProducts.length >= 3) {
        buildSlider(sliderProducts);
      } else {
        clearPlaceholder();
      }
    })
    .catch(function(e) {
      console.warn('PES slider fetch error:', e.message);
      clearPlaceholder();
    });
}

function money(val) {
  if (val >= 1000) return '$' + val.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
  return '$' + val.toFixed(2);
}

function buildSlider(products) {
  if (document.querySelector('.pes-promoted-slider')) return;
  
  // Find the product grid to insert before
  var grid = document.querySelector('.product-grid, .cust-prodlist-grid, .collection-product-grid, #product-grid, .grid.product-grid, .custm-mn-collecgridlist');
  if (!grid) return;
  
  var container = grid.parentNode || grid.parentElement;
  if (!container) return;
  
  var slider = document.createElement('div');
  slider.className = 'pes-promoted-slider';
  
  var header = document.createElement('div');
  header.className = 'pes-promoted-slider__header';
  header.innerHTML = 
    '<div class="pes-promoted-slider__title">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>' +
    'Current Production — Top Picks' +
    '</div>' +
    '<div class="pes-promoted-slider__nav">' +
    '<button class="pes-promoted-slider__btn pes-promoted-slider__btn--prev" type="button">&#8249;</button>' +
    '<button class="pes-promoted-slider__btn pes-promoted-slider__btn--next" type="button">&#8250;</button>' +
    '</div>';
  slider.appendChild(header);
  
  var track = document.createElement('div');
  track.className = 'pes-promoted-slider__track';
  
  products.forEach(function(p) {
    var card = document.createElement('a');
    card.className = 'pes-promo-card';
    card.href = '/products/' + p.handle;
    
    var badges = '';
    if (p.isValue) badges += '<span class="pes-promo-badge pes-promo-badge--value">Best Value</span>';
    if (p.isNew) badges += '<span class="pes-promo-badge pes-promo-badge--new">New</span>';
    if (p.isSale) badges += '<span class="pes-promo-badge pes-promo-badge--sale">Sale</span>';
    
    var priceHtml = '<span>' + money(p.price) + '</span>';
    if (p.compareAt) {
      priceHtml += '<span class="pes-promo-card__compare">' + money(p.compareAt) + '</span>';
    }
    
    var wpdHtml = '';
    if (p.wpd > 0) {
      wpdHtml = '<div class="pes-promo-card__wpd">' + money(p.wpd) + '/W &middot; ' + p.wattage + 'W</div>';
    }
    
    card.innerHTML = 
      '<img class="pes-promo-card__image" src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
      '<div class="pes-promo-card__body">' +
      '<div class="pes-promo-card__badges">' + badges + '</div>' +
      '<div class="pes-promo-card__title">' + p.title + '</div>' +
      '<div class="pes-promo-card__price">' + priceHtml + '</div>' +
      wpdHtml +
      '</div>';
    
    track.appendChild(card);
  });
  
  slider.appendChild(track);

  // CLS guard: swap the reserved placeholder instead of shifting the grid
  var ph = document.querySelector('.pes-promoted-slider-placeholder');
  if (ph && ph.parentNode) {
    ph.parentNode.insertBefore(slider, ph);
    ph.parentNode.removeChild(ph);
  } else {
    container.insertBefore(slider, grid);
  }
  
  // Setup navigation buttons
  var prevBtn = slider.querySelector('.pes-promoted-slider__btn--prev');
  var nextBtn = slider.querySelector('.pes-promoted-slider__btn--next');
  
  prevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    track.scrollBy({left: -440, behavior: 'smooth'});
  });
  
  nextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    track.scrollBy({left: 440, behavior: 'smooth'});
  });
  
  // Auto-scroll every 5 seconds
  var autoScroll = setInterval(function() {
    if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
      track.scrollTo({left: 0, behavior: 'smooth'});
    } else {
      track.scrollBy({left: 440, behavior: 'smooth'});
    }
  }, 5000);
  
  // Pause on hover
  slider.addEventListener('mouseenter', function() { clearInterval(autoScroll); });
  slider.addEventListener('mouseleave', function() {
    autoScroll = setInterval(function() {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
        track.scrollTo({left: 0, behavior: 'smooth'});
      } else {
        track.scrollBy({left: 440, behavior: 'smooth'});
      }
    }, 5000);
  });
}

function init() {
  try {
    injectStyles();
    fixCategoryTiles();
    
    if (window.location.pathname.indexOf('/collections/') >= 0) {
      fetchPromotedProducts();
    }
  } catch(e) {
    console.warn('PES tiles+slider init error:', e.message);
  }
}

window.pesTilesSliderV3 = true;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { try { init(); } catch(e) {} });
} else {
  try { init(); } catch(e) {}
}

document.addEventListener('shopify:section:load', function() {
  try { fixCategoryTiles(); } catch(e) {}
});

})();
